module.exports = __webpack_public_path__ + "img/0Q3B2213_L_Foamcore_MockedUp.d898cddb.jpg";